import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { AccountStatus } from '../models';
import { ICellRendererParams } from "ag-grid-community";

@Component({
    template: ` <span [className]="accountStatusClass">{{accountStatusString}}</span> `,
})
export class AccountStatusComponent implements ICellRendererAngularComp {

    accountStatusString: string;
    accountStatusClass: string;

    constructor() { }

    agInit(params: { data: { status: AccountStatus, statusString: string } }): void {
        this.accountStatusString = params.data.statusString;
        this.accountStatusClass = this.getAccountStatusClass(params.data.status);
    }

    getAccountStatusClass(status: AccountStatus) {
        switch (status) {
        case AccountStatus.Draft:
                return "badge text-bg-primary";
        case AccountStatus.Routing:
                return "badge text-bg-danger";
        case AccountStatus.Complete:
                return "badge text-bg-warning";
        case AccountStatus.Finalized:
                return "badge text-bg-success";
        default:
                return "badge text-bg-secondary";
        }
    }

    refresh(): boolean {
        return false;
    }
}